export class CustomerStatusDto {
    constructor(factor_id, name, isParallel = false, stageGroup = '') {
        this.id = factor_id;
        this.name = name;
        this.isParallel = isParallel;
        this.stageGroup = stageGroup;
    }
}